import { useCallback } from 'react';
import { useUser } from 'features/auth';
import type { CalendarPrincipalEventsQueryFilter } from '../../../../queries';
import type { Mode } from '../../../../types';
import { useGetEndDate } from './useGetEndDate';
import { useGetStartDate } from './useGetStartDate';

type P = {
  date: Date;
  mode: Mode;
};

export const useGetParamsForCalendarPrincipalEventsQuery = () => {
  const {
    nodeUserData: { _id },
  } = useUser();
  const getEndDate = useGetEndDate();
  const getStartDate = useGetStartDate();

  return useCallback(
    ({ date, mode }: P): { filter: CalendarPrincipalEventsQueryFilter } => ({
      filter: {
        calendarId: 'default',
        categories: ['TELEHEALTH_VISIT', 'VIDEO_CONFERENCE', 'WEBINAR', 'REMINDER'],
        endDate: getEndDate({ date, mode }),
        principalId: _id,
        startDate: getStartDate({ date, mode }),
      },
    }),
    [_id, getEndDate, getStartDate],
  );
};
